export default {
    computed: {
        waybillHeaders(){
            return [
              {
                text:'Id',
                value:'id',
                type:'disabled'
              },
              {
                text:'Custom Id',
                value: 'identifier',
                type: 'textfield'
              }, 
              {
                text:'Status',
                value: 'waybillStatus',
                type: 'textfield',
                hide_in_editor:true,
                hide_in_edit:true,
                chipColor:"orange",
                class:"userSelect"
              }, 
              {
                text:"Start Date",
                value:"estimatedStartDate",
                type:'date',
                hide_in_table:true
              },
              {
                text:"Start Date",
                value:"strEstimatedStartDate",
                type:'date',
                not_editable:true
              },
              {
                text:'User',
                value:'user',
                type:'multiselect',
                entity:'user',
                selector:'userFullName',
                multiple:false,
                chipColor:"orange",
                hide_client:true,
                hide_in_editor:false, 
                class:"userSelect"
              },
              {
                text:'Freight Forwarder',
                value:'freightForwarder',
                type:'multiselect',
                entity:'ff',
                selector:'userFullName',
                multiple:false,
                hide_client:true,
                chipColor:"green"
              },
              {
                text:'Assign to Freight Forwarder',
                value: 'assignToFF',
                type: 'checkbox',
                hide_client:true,
                hide_in_table:true
              },
            {
              text: 'QR Or Bar Code',
              value: 'qrCode',
              type:'qr_code',
              media:'qrCodeMedia',
              media_id:'qrCodeMediaId',
              media_type:5,
              hide_client:true,
              client_view_only:true
            },
              // {
              //   text:'Packages',
              //   value:'packages',
              //   type:'multiselect',
              //   entity:'package',
              //   selector:'identifier',
              //   multiple:true,
              //   chipColor:"blue",
              //   include_in_station:true
              // },
              {
                text:'Assign Drivers',
                value:'drivers',
                type:'multiselect',
                entity:'driver',
                selector:'email',
                multiple:true,
                chipColor:"green",
                hide_client:true
              },
              
              {
                text:'Assign Trucks',
                value:'trucks',
                type:'multiselect',
                entity:'truck',
                selector:'selectableInfo',
                multiple:true,
                chipColor:"orange",
                hide_client:true
              },
              {
                text:'Delivery Stations',
                value:'deliveryAddresses',
                type:'gmap',
                entity:'deliveryAddress',
                selector:'addresses',
                many_stations:true,
                has_fencing:true
              }
            ]
          }
    }
}